export default __webpack_public_path__ + "static/media/logo.8a0011d1.svg";